export default "__VITE_ASSET__BmxdYOoV__"